/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { type FunctionComponent } from 'react';
import { type JsiFrame, type JsiInterceptorRequest, type Request } from '../../interface/Crash';
import { RequestTableView } from './requestTableView';
import { convertObjectToHeaderArray } from './RequestHeaderView';

interface Props {
    request: Request | JsiInterceptorRequest;
}

export const ResponseHeaderView: FunctionComponent<Props> = (props: Props) => {
    const { request } = props;

    if (!request.response?.headers) return null;

    const _responseHeaders = Object.keys(request.response.headers).map((key) => [key, request.response?.headers[key]]);

    return <RequestTableView data={_responseHeaders as string[][]} headers={['name', 'value']} />;
};

export const JsiFrameResponseHeaderView: FunctionComponent<{ frame: JsiFrame }> = ({ frame }) => {
    if (!frame.response_headers) return <></>;
    return <RequestTableView data={convertObjectToHeaderArray(frame.response_headers)} headers={['name', 'value']} />;
};
